var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-scrollbar',{staticClass:"scrollbar-main"},[_c('Header'),_c('vue-page-transition',{attrs:{"name":"fade-in-left"}},[_c('router-view',{staticClass:"page"})],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }